import axios from "@/api/axios";

const API_URL = process.env.VUE_APP_API_HOST;

/**
 * @param {Object} params
 * @param {number[]} params.unitIds
 * @param {number} params.page
 * @param {number} params.perPage
 * @param {string} params.searchQuery
 * @param {AbortSignal} params.signal
 */
export async function getSectorsApi({
  unitIds,
  searchQuery = "",
  page = 1,
  perPage = 15,
  signal = null,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/sectors/get-sectors`,
    {
      params: {
        "company-ids": unitIds,
        search: searchQuery,
        "page[number]": page,
        "page[size]": perPage,
      },
    },
    {
      signal,
    }
  );
  return response.data;
}
